var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-layout" }, [
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
      },
      [
        _c("div", { staticClass: "custom-toolbar" }, [
          _c(
            "div",
            { staticClass: "custom-toolbar-start" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "Service Areas",
                    },
                  },
                },
                [_c("h3", { staticClass: "title" }, [_vm._v("Service Areas")])]
              ),
              _c("h3", { staticClass: "title delivery-window-crumb-title" }, [
                _vm._v(
                  "\n                       >    " +
                    _vm._s(_vm.deliveryWindowData.serviceAreaName) +
                    "    >   \n                    Delivery Windows\n                "
                ),
              ]),
            ],
            1
          ),
        ]),
      ]
    ),
    _c(
      "div",
      { staticClass: "md-layout-item md-size-100" },
      [
        _c(
          "md-card",
          [
            _c(
              "md-card-header",
              { staticClass: "md-card-header-icon md-card-header-black" },
              [
                _c(
                  "div",
                  { staticClass: "card-icon" },
                  [_c("md-icon", [_vm._v("my_location")])],
                  1
                ),
              ]
            ),
            _c(
              "md-card-content",
              [
                _c("div", { staticClass: "delivery-window-page-title" }, [
                  _vm._v(
                    "\n                    Delivery Windows\n                "
                  ),
                ]),
                _c(
                  "tabs",
                  {
                    staticClass: "custom-tab-list",
                    attrs: {
                      "tab-name": _vm.tabNames,
                      "selected-panel": _vm.currentTab,
                      "color-button": "primary",
                    },
                    on: { "switch-panel": _vm.beforeTabChanged },
                  },
                  [
                    _vm._l(_vm.tabNames, function (tabName, index) {
                      return _c(
                        "template",
                        { slot: "tab-pane-" + (index + 1) },
                        [
                          _c(
                            "div",
                            { key: index },
                            [
                              _c("service-areas-delivery-window", {
                                attrs: {
                                  "service-area-id": _vm.serviceAreaId,
                                  "day-of-the-week": _vm.dayOfTheWeek,
                                  "delivery-window-data":
                                    _vm.deliveryWindowData,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "custom-toolbar copy-from-toolbar-container" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "custom-toolbar-end copy-from-toolbar-end-container",
                      },
                      [
                        _c("vue-select", {
                          attrs: {
                            reduce: function (x) {
                              return x.id
                            },
                            label: "name",
                            options: _vm.copyFrom,
                            placeholder: "Copy from",
                          },
                          on: { input: _vm.handleCopyFromSelectedDay },
                          model: {
                            value: _vm.copyFromDay,
                            callback: function ($$v) {
                              _vm.copyFromDay = $$v
                            },
                            expression: "copyFromDay",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "custom-toolbar custom-delivery-window-toolbar",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "custom-toolbar-start" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass:
                              "md-button md-primary custom-back-button",
                            on: { click: _vm.handleBackToServiceAreas },
                          },
                          [
                            _vm._v(
                              "\n                            Back\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "custom-toolbar-end" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass:
                              "md-button md-primary custom-save-button",
                            on: {
                              click: function () {
                                return _vm.handleSaveDeliveryWindows()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            Save\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }